import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Inventory from "@/pages/Inventory";
import Trades from "@/pages/Trades";
import Returns from "@/pages/Returns";
import POS from "@/pages/POS";
import Events from "@/pages/Events";
import EventDetail from "@/pages/EventDetail";
import PreOrders from "@/pages/PreOrders";
import ReimburseSummary from "@/pages/ReimburseSummary";
import StockAdjustment from "@/pages/StockAdjustment";
import AuditLog from "@/pages/AuditLog";
import Users from "@/pages/Users";

function Protected({ children, adminOnly }) {
  const { user, isAdmin } = useAuth();
  if (user === null)
    return <div className="min-h-screen flex items-center justify-center bg-[#0B0E14] text-slate-500 font-mono text-sm">Memuat...</div>;
  if (user === false) return <Navigate to="/login" replace />;
  if (adminOnly && !isAdmin) return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/" element={<Protected><Dashboard /></Protected>} />
      <Route path="/inventory" element={<Protected><Inventory scope="produk" /></Protected>} />
      <Route path="/cards" element={<Protected><Inventory scope="kartu" /></Protected>} />
      <Route path="/trade" element={<Protected><Trades /></Protected>} />
      <Route path="/returns" element={<Protected><Returns /></Protected>} />
      <Route path="/adjustments" element={<Protected adminOnly><StockAdjustment /></Protected>} />
      <Route path="/pos" element={<Protected><POS /></Protected>} />
      <Route path="/events" element={<Protected><Events /></Protected>} />
      <Route path="/events/:id" element={<Protected><EventDetail /></Protected>} />
      <Route path="/preorders" element={<Protected><PreOrders /></Protected>} />
      <Route path="/reimburse" element={<Protected adminOnly><ReimburseSummary /></Protected>} />
      <Route path="/users" element={<Protected adminOnly><Users /></Protected>} />
      <Route path="/audit" element={<Protected adminOnly><AuditLog /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="top-right" theme="dark" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
